"use client";

import Form from "next/form";
import React from "react";

export function Search() {
  return (
    <Form
      action="/search"
      className="flex items-center border border-gray-300 rounded-md px-3 py-1 shadow-sm w-full md:w-auto"
    >
      <input
        type="text"
        name="query"
        placeholder="Search..."
        className="w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700"
      />
      <button
        type="submit"
        className="ml-2 text-white bg-purple-600 hover:bg-purple-700 px-3 py-1 rounded-md"
      >
        Search
      </button>
    </Form>
  );
}
